import { render, staticRenderFns } from "./btn_component_icon.vue?vue&type=template&id=4642c28f&scoped=true"
import script from "./btn_component_icon.vue?vue&type=script&lang=js"
export * from "./btn_component_icon.vue?vue&type=script&lang=js"
import style0 from "./btn_component_icon.vue?vue&type=style&index=0&id=4642c28f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642c28f",
  null
  
)

export default component.exports